import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import Box from '@material-ui/core/Box';
import {useAnalyticsFilters} from 'components/AnalyticsFilters/AnalyticsFiltersContext';
import {
  hasAnalyticsDateRange,
  resolveAnalyticsRequestDates
} from 'helpers/services/api/analyticsHelpers';
import {useDatePickerContext} from '../../Datepicker/DatePickerContext';
import Loading from '../../shared/Utils/Loading';
import {
  DashboardBox,
  DashboardBoxes,
  DashboardBoxNumber,
  DashboardBoxText,
  NoResultText
} from '../../../routes/App/dashboard/styles';
import {GET_CUSTOMERS_COUNT} from '../../../store/analyticsCustomersCount/action';

const TotalCustomers = ({disableFetch, dataOverride, loadingOverride}) => {
  const dispatch = useDispatch();
  const {locationId} = useSelector((state) => state.user);
  const {customersCount, customersCountLoading} = useSelector(
    (state) => state.analyticsCustomersCount
  );

  const date = useDatePickerContext();
  const filters = useAnalyticsFilters();

  useEffect(() => {
    if (disableFetch || !locationId || !hasAnalyticsDateRange(date)) {
      return;
    }
    const {startDate, endDate} = resolveAnalyticsRequestDates(date);
    dispatch(
      GET_CUSTOMERS_COUNT({
        startDate,
        endDate,
        channelTypes: filters.channelTypes,
        fulfillmentModes: filters.fulfillmentModes
      })
    );
  }, [
    date,
    locationId,
    dispatch,
    disableFetch,
    filters.channelTypes,
    filters.fulfillmentModes
  ]);

  const resolvedCustomersCount = dataOverride ?? customersCount;
  const resolvedLoading = loadingOverride ?? customersCountLoading;

  return (
    <>
      {resolvedLoading && <Loading />}
      {Object.keys(resolvedCustomersCount).length !== 0 && !resolvedLoading && (
        <DashboardBoxes>
          <DashboardBox>
            <DashboardBoxNumber>
              {' '}
              {resolvedCustomersCount.totalCustomers}
            </DashboardBoxNumber>
            {/* <DashboardBoxPercent className="PercentDecrease">2.5%</DashboardBoxPercent> */}
          </DashboardBox>
          <DashboardBox>
            <DashboardBoxText>
              <strong>
                ${resolvedCustomersCount.avgOrderAmount.toFixed(2)}
              </strong>{' '}
              Order Value (avg.)
            </DashboardBoxText>
            <DashboardBoxText>
              <strong>
                {resolvedCustomersCount.avgItemsPerOrder.toFixed(2)}
              </strong>{' '}
              Items per Order (avg.)
            </DashboardBoxText>
          </DashboardBox>
        </DashboardBoxes>
      )}
      {!resolvedLoading && Object.keys(resolvedCustomersCount).length === 0 && (
        <Box display='flex' alignItems='center' justifyContent='center' m={1}>
          <NoResultText>No results found for this date range!</NoResultText>
        </Box>
      )}
    </>
  );
};

TotalCustomers.defaultProps = {
  disableFetch: false,
  dataOverride: null,
  loadingOverride: undefined
};

TotalCustomers.propTypes = {
  disableFetch: PropTypes.bool,
  dataOverride: PropTypes.object,
  loadingOverride: PropTypes.bool
};

export default TotalCustomers;
